import { Typography, Grid, Paper } from '@mui/material';

export function ContainerCatalogue() {
    return (
        <Grid container component="main"
            sx={{
                height: "100vh",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "24px",
                    borderRadius: "6px"
                }}
                item
                xs={12}
                sm={8}
                md={3}
                component={Paper}
                elevation={0}
                square
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}>
                    <div style={{
                        margin: "8px",
                        padding: "8px",
                        textAlign: "center"
                    }}>
                        
                        <Typography variant="h6" data-testid="title" mt="10px">Sample Bottle Information Hub</Typography>
                    </div>                    
                </div>
            </Grid>
        </Grid>
    )
}
